import "core-js/modules/es6.function.name";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  id: function id(state) {
    return state.user.id;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permissions: function permissions(state) {
    return state.user.permissions;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  defaultRoutes: function defaultRoutes(state) {
    return state.permission.defaultRoutes;
  },
  topbarRouters: function topbarRouters(state) {
    return state.permission.topbarRouters;
  },
  sidebarRouters: function sidebarRouters(state) {
    return state.permission.sidebarRouters;
  },
  changeHosindex: function changeHosindex(state) {
    return state.permission.changeHosindex;
  },
  webInfo: function webInfo(state) {
    return state.app.webInfo;
  },
  navbarIndex: function navbarIndex(state) {
    return state.permission.navbarIndex;
  },
  defaultProject: function defaultProject(state) {
    return state.permission.defaultProject;
  },
  uploadList: function uploadList(state) {
    return state.user.uploadList;
  }
};
export default getters;